<template>
  <div>
    <b-form-group>
      <ValidationProvider v-slot="{errors, reset }" rules="required|unique" mode="lazy">
      <b-input-group class="col-md-7 px-0" :class="{'mb-2': !!errors && errors.length > 0}">
        <b-form-input
            id="vendor"
            type="text"
            v-model="vendor"
            placeholder="Markenname"
            data-vv-delay="1000"
            :disabled="!vendorEmpty"
            @input="reset"
            :class="{ 'border-warning': !!errors && errors.length > 0}"
            @focusin="reset"
            @change="$emit('input', vendor)">
        </b-form-input>
        <template #prepend>
          <b-input-group-text >Produzent</b-input-group-text>
        </template>
        <template #append v-if="!currentVendor">
          <b-button  @click.prevent="save" :disabled="inProgress || vendor === ''">Speichern
            <b-spinner v-if="inProgress" small></b-spinner>
          </b-button>
        </template>
      </b-input-group>
      <span v-if="!!errors && errors.length > 0" class="alert-warning px-2 py-1 mt-2 rounded-1 col-md-7">{{ errors[0] }}<br></span>
      <small v-if="!currentVendor"><b>Achtung:</b> Nach dem speichern kann der Markenname nicht mehr geändert werden</small>
      <small v-else>Bitte kontaktieren Sie den Marktplatz-Support, um Ihren Markenname zu ändern.</small>
      </ValidationProvider>
    </b-form-group>
  </div>
</template>

<script>

import {extend, ValidationProvider} from "vee-validate";
import firebase from "firebase";
import "firebase/firestore";


async function vendorUnique(vendorName) {
  const db = firebase.firestore();
  const document = await db.collection('vendors').doc(vendorName).get()
  return !document.exists;
}


extend('unique', {
  validate(value){
    return vendorUnique(value);
  },
  message: "This vendor is already registered"
})

export default {
  data() {
    return {
      vendor: '',
      currentVendor: '',
      user: null,
      inProgress: false,
    }
  },
  components: {
    ValidationProvider
  },
  computed: {
    db(){
      return firebase.firestore()
    },
    vendorEmpty(){
      return this.currentVendor === ''
    }

  },
  methods: {
    save() {
      this.vendor = this.vendor.trim();
      if (this.currentVendor !== this.vendor) {
        this.inProgress = true;
        const newVendorReference = this.db.collection('vendors').doc(this.vendor);
        let currentVendorReference;
        try {
          currentVendorReference = this.db.collection('vendors').doc(this.currentVendor);
        } catch(FirebaseError) {
          currentVendorReference = null;
        }
        this.db.runTransaction(transaction => {
          return transaction.get(newVendorReference)
        }).then(async vendorDocument => {
          if (vendorDocument.exists) {
            throw "Vendor already registered"
          }
          await newVendorReference.set({userId: this.user.uid})
          if (currentVendorReference !== null) {
            currentVendorReference.delete();
          }
          this.currentVendor = this.vendor;
          this.$store.commit('user/setProfileUpdate', {vendor: this.vendor})
          await this.$store.dispatch('user/saveProfile')
        }).catch(
            (error) => {
              console.log('Error during vendor transaction' + error);
              this.$bvModal.show('error-modal')
            }
        )
        .finally(
            () => {
              this.inProgress = false
            }
        );
      }
    }
  },
  created() {
    firebase.auth().onAuthStateChanged(user => {
      this.db.collection('vendors').where('userId', '==', user.uid).get().then(querySnapshot => {
        try {
          this.vendor = querySnapshot.docs[0].id;
        } catch (TypeError) {
          this.vendor = ''
        }
        this.currentVendor = this.vendor;
        this.user = user;
      })
    })
  }
}
</script>
